/**
 * Wave 379 R1 · Admin Brain Decision Graph.
 *
 * Zod schemas for autonomy decision flow visualization.
 * Renders DAG: anomaly → orchestration_run → pm_proposals → autonomy_actions → goal_plan_steps.
 */

import { z } from 'zod';

export type GraphNodeKind = 'anomaly' | 'orchestration_run' | 'pm_proposal' | 'autonomy_action' | 'goal_plan_step';
export type EdgeKind = 'triggered' | 'decided' | 'executed' | 'advanced' | 'audit';

export const GraphNodeSchema = z.object({
  id: z.string(),
  kind: z.enum(['anomaly', 'orchestration_run', 'pm_proposal', 'autonomy_action', 'goal_plan_step']),
  label: z.string(),
  status: z.string(),
  ts: z.string(), // ISO timestamp
});

export const GraphEdgeSchema = z.object({
  from: z.string(),
  to: z.string(),
  kind: z.enum(['triggered', 'decided', 'executed', 'advanced', 'audit']),
  ts: z.string(), // ISO timestamp
});

export const DecisionGraphDTOSchema = z.object({
  nodes: z.array(GraphNodeSchema),
  edges: z.array(GraphEdgeSchema),
});

export type GraphNode = z.infer<typeof GraphNodeSchema>;
export type GraphEdge = z.infer<typeof GraphEdgeSchema>;
export type DecisionGraphDTO = z.infer<typeof DecisionGraphDTOSchema>;
